document.addEventListener('click', function (event) {
  var btn = event.target.closest('.dual-text-add-to-cart');
  if (!btn) return;

  var variantId = btn.getAttribute('data-product-id');
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  })
    .then(function (response) {
      return response.json();
    })
    .then(function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (window.theme && window.theme.cartDrawer) {
        window.theme.cartDrawer.open();
      }
    })
    .catch(function (error) {
      console.error('Error adding to cart:', error);
    });
});
